import { useAuth } from '../../auth/AuthContext';

// Quién hace qué con un cobro (16-oct-2026). Espejo de SecurityConfig y CobroService en el backend:
// si se cambia uno hay que cambiar el otro, porque esconder un botón no protege el dato.
//  - 'cobranzas.cobrar' (todos los roles): ver el cobro, registrar pagos, reprogramar el plan de
//    cuotas, gestiones, recordatorios y el alta.
//  - 'cobranzas.editar' (ADMIN/PROGRAMADOR): además, la configuración (pago único o en cuotas,
//    haberes, porcentaje, monto), crear cobros a mano y darlos de baja.
//  - Excepción: el cobro de un plan de pago lo configura cualquiera (lo arma quien abrió el plan).

export const TIPO_PLAN_PAGO = 'PLAN_PAGO';

/** El cobro es solo de trámites de plan de pago. */
export function esCobroDePlanDePago(cobro) {
    const tramites = cobro?.tramites || [];
    return tramites.length > 0 && tramites.every((t) => String(t?.tipoTramiteNombre || '').toUpperCase() === TIPO_PLAN_PAGO);
}

/** El trámite es un plan de pago (los DTO de trámite traen el tipo con distintas formas). */
export function esTramitePlanDePago(tramite) {
    const nombre = tramite?.tipoTramite?.nombre || tramite?.nombreTipoTramite || tramite?.tipoTramite;
    return String(nombre || '').toUpperCase() === TIPO_PLAN_PAGO;
}

export function usePermisosCobro(cobro) {
    const puede = useAuth()?.puede;
    const administra = Boolean(puede && puede('cobranzas.editar'));
    return {
        puedeOperar: administra || Boolean(puede && puede('cobranzas.cobrar')),
        puedeConfigurar: administra || esCobroDePlanDePago(cobro),
        puedeDarDeBaja: administra,
        administra,
    };
}
